/* import __COLOCATED_TEMPLATE__ from './step-container.hbs'; */
import Component from '@glimmer/component';

export default class StepContainerComponent extends Component {}
